import clsx from 'clsx'

import { useGetKeyPairValue, MILKvKeys } from 'api/microlearning/useAPIKeyValue'
import { AksiNyataSessionState } from 'types/microlearning'

import type { OverallProgress } from 'types/microlearning'

const useTopicSurveyBanner = () => {
  const { data, status } = useGetKeyPairValue<{
    active: boolean
    bannerUrl: string
    surveyUrl: {
      DEFAULT: string
      COMPLETED: string
      NEED_REVISION: string
      VALIDATED: string
    }
  }>(MILKvKeys.TopicSurveyBanner)
  const getSurveyBanner = (
    topicProgress: OverallProgress[] = [],
    options?: { className?: string }
  ) => {
    if (status !== 'success' || !data?.data?.active) return null

    const aksiNyataStatus = new Set<OverallProgress['aksiNyata']['state']>(
      topicProgress.map(({ aksiNyata: { state } }) => state)
    )

    /** Should be ranked like this as the product specification stated */
    const statusOrder: OverallProgress['aksiNyata']['state'][] = [
      AksiNyataSessionState.Validated,
      AksiNyataSessionState.NeedRevision,
      AksiNyataSessionState.Completed,
    ]

    const url = ((surveyUrl) => {
      for (let state of statusOrder) {
        if (aksiNyataStatus.has(state)) {
          return surveyUrl[state]
        }
      }
      return surveyUrl.DEFAULT
    })(data.data.surveyUrl)

    return (
      <div
        className={clsx(
          options?.className,
          'relative grid place-content-center'
        )}
      >
        <a
          href={url}
          className="overlay-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={data.data.bannerUrl}
            alt="Survey Banner"
            className="w-full aspect-[336/92] max-w-md"
          />
        </a>
      </div>
    )
  }

  return getSurveyBanner
}

export default useTopicSurveyBanner
